// Site-wide constants for MiMaquinaSegura.cl
export const BRAND = "MiMaquinaSegura.cl";
export const SLOGAN = "Seguros para maquinaria, equipos y tecnología.";
export const CONTACT_EMAIL = "Contacto@MiMaquinaSegura.cl";

// Contacto comercial: ejecutivo que ayuda a conseguir tu mejor opción / cotizar.
export const COMMERCIAL_WHATSAPP_DIGITS = "56942964199";
export const COMMERCIAL_WHATSAPP_MESSAGE =
  "Hola, quiero cotizar el seguro para mi maquinaria o equipo electrónico.";

// Contacto de gestión de siniestros.
export const CLAIMS_WHATSAPP_DIGITS = "56942964199";
export const CLAIMS_WHATSAPP_MESSAGE =
  "Hola, necesito asistencia con un siniestro de mi maquinaria / equipo.";

export const whatsappUrl = () =>
  `https://wa.me/${COMMERCIAL_WHATSAPP_DIGITS}?text=${encodeURIComponent(COMMERCIAL_WHATSAPP_MESSAGE)}`;

export const claimsWhatsappUrl = () =>
  `https://wa.me/${CLAIMS_WHATSAPP_DIGITS}?text=${encodeURIComponent(CLAIMS_WHATSAPP_MESSAGE)}`;

// Aseguradoras de respaldo (chips de marca hasta subir logos oficiales).
export const INSURERS = [
  { id: "bci", name: "BCI Seguros" },
  { id: "sura", name: "SURA" },
  { id: "zurich", name: "Zurich" },
  { id: "reale", name: "Reale" },
  { id: "hdi", name: "HDI" },
  { id: "mapfre", name: "MAPFRE" },
];

// Categorías de industria / tipo de máquina asegurada.
export const INDUSTRIA_OPTIONS = [
  { value: "agricola", label: "Maquinaria Agrícola" },
  { value: "construccion", label: "Maquinaria de Construcción" },
  { value: "mineria", label: "Maquinaria de Minería" },
  { value: "electronicos", label: "Equipos Electrónicos" },
  { value: "medicas", label: "Máquinas Médicas" },
  { value: "vehiculos", label: "Vehículos (camiones, camionetas, furgones)" },
];

// Info descriptiva por categoría (usada en el showcase y coberturas).
export const MACHINE_CATEGORIES = [
  {
    id: "agricola",
    name: "Maquinaria Agrícola",
    tag: "Tractores · Cosechadoras · Fumigadoras",
    desc:
      "Cubre daños físicos de la maquinaria y la responsabilidad civil por daños corporales y/o materiales causados a terceros por el equipo.",
    icon: "🚜",
  },
  {
    id: "construccion",
    name: "Construcción y Minería",
    tag: "Excavadoras · Grúas · Cargadores · Camiones mineros",
    desc:
      "Protege el equipo pesado en obra y faena minera: daños físicos y responsabilidad civil frente a terceros.",
    icon: "🏗️",
  },
  {
    id: "electronicos",
    name: "Equipos Electrónicos",
    tag: "Computadores · Celulares · Comunicaciones · Medición · Médicos",
    desc:
      "Equipos electrónicos de uso particular o comercial contra daños físicos: computación, comunicaciones, medición y equipos médicos.",
    icon: "💻",
  },
];
